import React from 'react';
import Container from './Container.js';
import mapElement from '../helpers/elementMapper.js';
const FeatureHighlight = ({
  headline,
  elements,
  imgPosition = 'left',
  imgUrl,
  imgAlt,
  portraitImgUrl = null,
  autoWidth = true
}) => {
  const autotWidthClass = autoWidth ? 'ebds-feature-highlight--auto-width' : '';
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: `ebds-feature-highlight ebds-feature-highlight--${imgPosition} ${autotWidthClass}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-feature-highlight__image"
  }, /*#__PURE__*/React.createElement("picture", null, portraitImgUrl && /*#__PURE__*/React.createElement("source", {
    media: "(max-width:767px)",
    srcSet: portraitImgUrl
  }), /*#__PURE__*/React.createElement("img", {
    src: imgUrl,
    alt: imgAlt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ebds-feature-highlight__body"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), elements.map((element, index) => /*#__PURE__*/React.createElement("div", {
    key: index
  }, mapElement(element, index))))));
};
export default FeatureHighlight;